import React from 'react';
import { getDryRun, setDryRunParameter } from '../utils.tsx';
import { formatAvailableDate } from '../../ProductManagement/formatAvailableDate';
import { getCachedBusinessTimeZone } from '../../../hooks/useBusinessTimeZone';

const formatAvailability = (iso: string | null): string => {
    if (!iso) return '-';
    const { date, time } = formatAvailableDate(iso, getCachedBusinessTimeZone());
    return `${date} ${time}`;
};

export interface DeduplicateMainProductsReportGroup {
    groupId: number;
    keeperSynthKey: string;
    manufacturerCode: string | null;
    name: string | null;
    originalPrice: number | null;
    availableDate: string | null;
    deactivatedSynthKeys: string[];
}

export interface DeduplicateMainProductsReport {
    dryRun: boolean;
    duplicateGroups: number;
    mainProductsToDeactivate: number;
    deactivatedMainProducts: number;
    groups: DeduplicateMainProductsReportGroup[];
}

export const deduplicateMainProductsCode = 'deduplicate-main-products';

export const isDeduplicateMainProductsReport = (report: unknown): report is DeduplicateMainProductsReport => {
    return typeof report === 'object'
        && report !== null
        && Array.isArray((report as { groups?: unknown }).groups);
};

export const renderDeduplicateMainProductsReport = (report: DeduplicateMainProductsReport) => (
    <div className="operations-report">
        <div className="operations-report-stats">
            <div>
                <span>Режим</span>
                <strong>{report.dryRun ? 'Тестовый' : 'Боевой'}</strong>
            </div>
            <div>
                <span>Групп дублей</span>
                <strong>{report.duplicateGroups}</strong>
            </div>
            <div>
                <span>К деактивации</span>
                <strong>{report.mainProductsToDeactivate}</strong>
            </div>
            <div>
                <span>Деактивировано</span>
                <strong>{report.deactivatedMainProducts}</strong>
            </div>
        </div>

        <div className="operations-table-wrap operations-report-table">
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>Группа</th>
                        <th>Оставленная SKU</th>
                        <th>Артикул</th>
                        <th>Наименование</th>
                        <th>Цена</th>
                        <th>Срок</th>
                        <th>Деактивированные SKU</th>
                    </tr>
                </thead>
                <tbody>
                    {report.groups.map(group => (
                        <tr key={group.groupId}>
                            <td>{group.groupId}</td>
                            <td>{group.keeperSynthKey}</td>
                            <td>{group.manufacturerCode ?? '-'}</td>
                            <td>{group.name ?? '-'}</td>
                            <td>{group.originalPrice ?? '-'}</td>
                            <td>{formatAvailability(group.availableDate)}</td>
                            <td>
                                <div className="operations-sku-list">
                                    {group.deactivatedSynthKeys.map((sku, index) => (
                                        <span key={`${sku}-${index}`}>{sku}</span>
                                    ))}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);

export const renderDeduplicateMainProductsParameters = ({
    editParams,
    onEditParamsChange
}: {
    editParams: string;
    onEditParamsChange: (value: string) => void;
}) => (
    <label className="operations-toggle">
        <input
            type="checkbox"
            checked={getDryRun(editParams)}
            onChange={e => onEditParamsChange(setDryRunParameter(editParams, e.target.checked))}
        />
        <span>Тестовый запуск</span>
    </label>
);

export const deduplicateMainProductsExtension = {
    code: deduplicateMainProductsCode,
    renderParameterEditor: renderDeduplicateMainProductsParameters,
    renderReport: (report: unknown) => (
        isDeduplicateMainProductsReport(report)
            ? null //renderDeduplicateMainProductsReport(report)
            : null
    )
};
